import { default as client_lookups, default as lookups } from '@/assets/json/clientLookups.json'
import client_config from '@/assets/json/client_config.json'
import use140Actions from '@/composables/actions/use140Actions'
import use57Actions from '@/composables/actions/use57Actions.js'
import use24Actions from '@/composables/actions/use24Actions.js'
import use375Actions from '@/composables/actions/use375Actions'
import use376Actions from '@/composables/actions/use376Actions'
import use445Actions from '@/composables/actions/use445Actions'
import use446Actions from '@/composables/actions/use446Actions'
import use573Actions from '@/composables/actions/use573Actions'
import use663Actions from '@/composables/actions/use663Actions'
import use713Actions from '@/composables/actions/use713Actions'
import use719Actions from '@/composables/actions/use719Actions'
import use761Actions from '@/composables/actions/use761Actions'
import use838Actions from '@/composables/actions/use838Actions'
import use919Actions from '@/composables/actions/use919Actions.js'
import use920Actions from '@/composables/actions/use920Actions'
import use922Actions from '@/composables/actions/use922Actions'
import use162Actions from '@/composables/actions/use162Actions'
import use440Actions from '@/composables/actions/use440Actions'
import use495Actions from '@/composables/actions/use495Actions'
import use714Actions from '@/composables/actions/use714Actions'
import { isGpaDecimalValid } from '../useRuleHandler'
import i18n from '@/i18n/i18n'
import router from '@/router'
import {
  default as apiHelperService,
  default as axiosInstance,
  axiosNoResponseInterceptor
} from '@/services'
import { useAuthStore } from '@/stores/auth'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'
import { useLookupsStore } from '@/stores/lookups'
import { notify } from 'notiwind'
import useButtonActions from './useButtonActions'
import axios from 'axios'

async function checkIfPersonHasGoldenVisa(response) {
  const authStore = useAuthStore()

  const {
    application: { establishment }
  } = client_lookups

  const {
    user: { applicationId }
  } = authStore

  const isEstablishmentUser = applicationId == establishment
  const { isCancelledFile, serviceId } = response
  if (!isEstablishmentUser) return
  if (!isCancelledFile) return

  const {
    goldenFilesServiceIds: { TenYearsResidency, FiveYearResidency, ResidencyVisa }
  } = client_lookups
  const tenYearResidencyIds = Object.values(TenYearsResidency)
  const fiveYearResidencyIds = Object.values(FiveYearResidency)
  const residencyIds = Object.values(ResidencyVisa)

  if (
    tenYearResidencyIds.includes(serviceId) ||
    fiveYearResidencyIds.includes(serviceId) ||
    residencyIds.includes(serviceId)
  ) {
    // TODO: show a confirmation dialog
    const res = confirm('personHasGoldenResidencyResidenceFile')
  }
}
const _searchFingerprintExemptionRrequests = async () => {
  const formStore = useFormStore()
  const result = await axiosInstance.get(
    `/api/icaRequest/fingerprint-exemption-requests/search/${formStore.form.values.personUnifiedNumber}`
  )
  if (result && result.length > 0) {
    formStore.extraMap.searchFingerprintExemptionRrequestsList = result
    formStore.extraMap.haveFingerprintExemptionRrequests = true
  }
}

const getPersonInfoByFileNumber = async ({ source: module } = {}) => {
  const formStore = useFormStore()
  const moduleOneFiledKeyList = [
    'resiDepartmentCode',
    'resiYear',
    'resiServiceCode',
    'resiSequenceNumber'
  ]
  const moduleTwoFiledKeyList = [
    'resiVisaDepartmentCode',
    'resiVisaYear',
    'resiVisaServiceCode',
    'resiVisaSequenceNumber'
  ]
  switch (module) {
    case 1:
      if (moduleOneFiledKeyList.some((key) => !formStore.form.values[key])) {
        return
      } else {
        const { resiDepartmentCode, resiYear, resiServiceCode, resiSequenceNumber } =
          formStore.form.values
        formStore.extraMap = {
          ...formStore.extraMap,
          ...{
            fileDepartmentCode: formStore.form.values.resiDepartmentCode,
            fileYear: formStore.form.values.resiYear,
            fileTypeCode: formStore.form.values.resiServiceCode,
            fileSequenceNumber: formStore.form.values.resiSequenceNumber,
            fileNumber: `${resiDepartmentCode}${resiYear}"0"${resiServiceCode.slice(-2)}000000${resiSequenceNumber.slice(-7)}`
          }
        }
      }
      break
    case 2:
      if (moduleTwoFiledKeyList.some((key) => !formStore.form.values[key])) {
        return
      } else {
        const {
          resiVisaDepartmentCode,
          resiVisaYear,
          resiVisaServiceCode,
          resiVisaSequenceNumber
        } = formStore.form.values
        formStore.extraMap = {
          ...formStore.extraMap,
          fileDepartmentCode: formStore.form.values.resiVisaDepartmentCode,
          fileYear: formStore.form.values.resiVisaYear,
          fileTypeCode: formStore.form.values.resiVisaServiceCode,
          fileSequenceNumber: formStore.form.values.resiVisaSequenceNumber,
          fileNumber: `${resiVisaDepartmentCode}${resiVisaYear}"0"${resiVisaServiceCode.slice(-2)}000000${resiVisaSequenceNumber.slice(-7)}`
        }
      }
      break
    default:
      break
  }

  if (
    router.currentRoute.value.params.serviceId !=
      lookups.ServiceTransactions.DivorcedOrWidowedServiceIssueUnifiedForm &&
    (formStore.extraMap.fileNumber || module == 0 || formStore.form.values.personUnifiedNumber)
  ) {
    let result = await axiosInstance.get(`/api/user/checkPersonInfo`, {
      params: {
        unifiedNumber: formStore.form.values.personUnifiedNumber,
        serviceCode: formStore.extraMap.fileTypeCode,
        departmentCode: formStore.extraMap.fileDepartmentCode,
        serviceYear: formStore.extraMap.fileYear,
        sequenceNumber: formStore.extraMap.fileSequenceNumber
      }
    })
    if (result) {
      formStore.form.setValues({
        personUnifiedNumber: result.unifiedNumber
      })
      if (formStore.form.values.personUnifiedNumber) {
        await _searchFingerprintExemptionRrequests()
      }
      if (result && result.hasOldIdentityNumber) {
        formStore.extraMap.showChangePersonPhoto = client_config.EnableChangePersonalPhoto
        formStore.extraMap = {
          ...formStore.extraMap,
          showOldEidaExpiryDate: true,
          showidentityNumberField: true,
          userHadTheOldCardOrCopy: 1
        }
        // $scope.identityNumberRequired = 'required'
        // $scope.oldEidaExpiryDateRequired = 'required'
      } else {
        formStore.extraMap.showChangePersonPhoto = false
        formStore.extraMap = {
          ...formStore.extraMap,
          showOldEidaExpiryDate: false,
          showidentityNumberField: false,
          identityNumber: null,
          oldEidaExpiryDate: null
        }
      }
    } else {
      formStore.extraMap = {
        ...formStore.extraMap,
        showOldEidaExpiryDate: false,
        showidentityNumberField: false
      }
    }
  }

  if (
    router.currentRoute.value.params.serviceId !=
    lookups.ServiceTransactions.DivorcedOrWidowedServiceIssueUnifiedForm
  ) {
    // TODO: CheckFines
  }
}

async function getWifeInfoByIdntityNumberAndUnifiedNumber() {
  const formStore = useFormStore()
  const { familyMemIdnNumber, familyMemUnNumber } = formStore.form.values
  if (!familyMemIdnNumber || !familyMemUnNumber) return

  const serviceId = router.currentRoute.value.params.serviceId

  const params = {
    IsUnifiedNumber: false,
    ServiceTransId: serviceId,
    wifeIdentityNumber: familyMemIdnNumber,
    wifeUnifiedNumber: familyMemUnNumber
  }
  const path = '/api/individual/usersInfoByIdentityNumberOrUnifiedNumber'
  const data = await axiosInstance.get(path, {
    params
  })

  const {
    wifeOrHusbandType: { residentWife, citizenWife, residentHusband },
    uaeNationality,
    ServiceTransactions: { familyBookAddWifeOrHusband }
  } = lookups

  if (!data) {
    throw Error('personNumberIsWrongOrNotRelated')
  }

  const { gender, passportNationalityId, fileModuleId } = data

  formStore.form.setFieldValue('wifeOrHusbandFileModuleId', fileModuleId)

  if (gender == 2) {
    formStore.form.setFieldValue(
      'wifeOrHusbandType',
      passportNationalityId == 1 ? citizenWife : residentWife
    )
  }

  if (gender == 1 && passportNationalityId != 1) {
    formStore.form.setFieldValue('wifeOrHusbandType', residentHusband)
  }

  if (serviceId == familyBookAddWifeOrHusband && passportNationalityId == uaeNationality) {
    formStore.form.setFieldValue('otherNationalityId', passportNationalityId)
  }
}

async function getIdentityNumberOrUnifiedNumber(params) {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const {
    user: { applicationId }
  } = authStore
  const { identityNumber = '', personUnifiedNumber = '' } = formStore.form.values
  if (!identityNumber && !personUnifiedNumber) return
  try {
    let res = await apiHelperService.get(
      applicationId == 2
        ? `/api/typingCenter/citizenServices/draft/usersInfoByIdentityNumberOrUnifiedNumber`
        : `/api/establishment/usersInfoByIdentityNumberOrUnifiedNumber`,
      {
        params
      }
    )
    if (!res) return
    const { unifiedNumber = '', identityCardNumber = '' } = res
    if (unifiedNumber) {
      formStore.form.setValues({
        personUnifiedNumber: unifiedNumber || personUnifiedNumber
      })
    }
    if (identityCardNumber) {
      formStore.form.setValues({
        personIdentityNumber: identityCardNumber || identityNumber
      })
    }
  } catch (error) {
    formStore.form.setValues({
      personUnifiedNumber: null,
      personIdentityNumber: null
    })
  }
}

async function checkBeneficiary() {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const {
    departemntCode = '',
    fileYear = '',
    serviceCode = '',
    fileNumber = '',
    personUnifiedNumber = ''
  } = formStore.form.values
  if (!departemntCode || !fileYear || !serviceCode || !fileNumber || !personUnifiedNumber) return
  const params = {
    serviceTransactionId,
    personUnifiedNumber,
    departemntCode,
    fileYear,
    serviceCode,
    fileNumber
  }
  let res = await apiHelperService.get(`/api/courtRequest/draft/hideSponsorSection`, {
    params
  })
  if (!res) return
  formStore.draft.request = {
    ...formStore.draft.request,
    hideSponsorSection: res || false
  }
}

async function checkForViolatedFiles(source) {
  const {
    requestCancelTransaction: { visaCancel },
    transactionReason: { visaDeadInsideCoutry }
  } = client_lookups
  const { serviceId } = router.currentRoute.value.params

  const PERSON_UNIFIED_NUMBER = 1
  const PERSON_FILE_NUMBER = 2

  const formStore = useFormStore()

  const {
    personUnifiedNumber,
    departmentCode,
    serviceYear,
    serviceCode,
    sequenceNumber,
    transactionReasonId
  } = formStore.form.values || formStore.draft.request

  if (source == PERSON_UNIFIED_NUMBER && !personUnifiedNumber) {
    return
  }

  if (
    source == PERSON_FILE_NUMBER &&
    [departmentCode, serviceYear, serviceCode, sequenceNumber].some((x) => !x)
  ) {
    return
  }

  if (serviceId == visaCancel && transactionReasonId == visaDeadInsideCoutry) {
    Object.assign(formStore.extraMap, {
      finesWarningMessage: null,
      showFinesWarningMessage: false
    })
  }

  await checkFines()
}

async function checkFines() {
  const { serviceId } = router.currentRoute.value.params
  const { multipleRequest } = client_config
  const formStore = useFormStore()

  const {
    sponsorNumber,
    personUnifiedNumber,
    departmentCode,
    serviceYear,
    serviceCode,
    sequenceNumber,
    sponsorTypeId,
    sponsorDepartmentId
  } = formStore.form.values || formStore.draft.request

  const response = await axiosInstance.get('/api/bulkRequest/violatedFiles', {
    params: {
      sponsorUnifiedNumber: sponsorNumber,
      personUnifiedNumber,
      fileDepartmentCode: departmentCode,
      fileYear: serviceYear,
      fileTypeCode: serviceCode,
      fileSequenceNumber: sequenceNumber,
      serviceTransId: serviceId,
      sponsorTypeId,
      sponsorImmigrationId: sponsorDepartmentId
    }
  })

  if (!response || !Array.isArray(response) || (response ?? []).length === 0) {
    Object.assign(formStore.extraMap, {
      finesWarningMessage: null,
      showFinesWarningMessage: false
    })
  }

  const files = response.map((r) =>
    [r.departmentCode, r.serviceYear, r.serviceCode, r.sequenceNumber].join(', ')
  )

  let finesMessage = i18n.global.t('existViolatedFilesWithAutoReq1', [files.join(',')])
  let finesMessageSuffix = i18n.global.t('existViolatedFilesWithAutoReq2')
  if (multipleRequest) {
    finesMessage = i18n.global.t('existViolatedFiles1', [files.join(',')])
    finesMessageSuffix = i18n.global.t('existViolatedFiles2')
  }

  let finalMessage = `${finesMessage} ${finesMessageSuffix}`

  Object.assign(formStore.extraMap, {
    finesWarningMessage: finalMessage,
    showFinesWarningMessage: true
  })
}

async function loadDraftAfterCloning(requestNumber) {
  await useButtonActions().fetchRequestRecord(requestNumber)
}

async function cloneRequestDraft(draftNumber) {
  await useButtonActions().fetchDraftByRequestNumber(draftNumber)
}

async function checkEligibility({ serviceTransactionId, othersBeneficiaryType }) {
  const formStore = useFormStore()
  const result = await axiosInstance.get(
    `/api/refundRequest/${serviceTransactionId}/${formStore.form.values.referenceRequestNumber}/${undefined}/${othersBeneficiaryType}/checkEligibilityForWhiteListRefund`
  )
}

async function checkInitialApprovalRequest(params) {
  // this function should not work for serviceId 142
  const formStore = useFormStore()
  const authStore = useAuthStore()

  const { number, departmentID } = authStore.establishmentInfo
  const departments = await useLookupsStore().fetchLookup('/api/lookup/departments')
  const estDepartment = departments.find((d) => d.id == departmentID)

  const initialApprovalPath = '/api/typingCenter/establishment/other/checkEstabInitialApproval'
  const body = {
    ...params,
    administrativeRegionId: estDepartment?.administrativeRegionId,
    establishmentNumber: number
  }

  try {
    const initialApprovalResult = await axiosInstance.post(initialApprovalPath, body)

    if (!initialApprovalResult || initialApprovalResult?.checkApprovalFlag) {
      notify(
        {
          group: 'error',
          title: i18n.global.t('errorSetDefaultAddress'),
          text: i18n.global.t('initialApprovalNotExist')
        },
        6000
      )

      return
    }

    const approvalInfoPath = `/api/typingCenter/establishment/other/${params.referenceRequestNumber}`
    const approvalInfoResponse = await axiosInstance.get(approvalInfoPath)

    const { establishmentRequestTypeId, arabicEstablishmentNewName, englishEstablishmentNewName } =
      approvalInfoResponse

    const {
      establishmentRequestTypes: {
        addRelatedPerson,
        concession: requestConcession,
        changeTradeName,
        addCommercialActivity
      },
      editEstablishmentCardReasons: {
        changeOwners,
        concession: editConcession,
        changeTradeName: editChangeTradeName,
        changeCommercialActivity
      }
    } = client_lookups

    if ([addRelatedPerson, requestConcession].includes(establishmentRequestTypeId)) {
      Object.assign(formStore.draft.request, {
        transactionReasonId:
          establishmentRequestTypeId == addRelatedPerson ? changeOwners : editConcession
      })
    }

    if (establishmentRequestTypeId == changeTradeName) {
      Object.assign(formStore.draft.request, {
        transactionReasonId: editChangeTradeName,
        arabicEstablishmentNewName,
        englishEstablishmentNewName
      })
    }

    if (establishmentRequestTypeId == addCommercialActivity) {
      Object.assign(formStore.draft.request, {
        transactionReasonId: changeCommercialActivity
      })
    }
  } catch (error) {
    formStore.form.resetField('referenceRequestNumber')
    return
  }
}

async function fetchFines() {
  const globalStore = useGlobalStore()
  const formStore = useFormStore()
  const authStore = useAuthStore()

  const { departmentCode, serviceYear, serviceCode, sequenceNumber, fileModuleId } =
    formStore.form.values

  if ([departmentCode, serviceYear, serviceCode, sequenceNumber].some((x) => !x)) return

  const params = {
    serviceTransactionId: globalStore.startedService.serviceTransactionId,
    departmentCode,
    serviceYear,
    serviceCode,
    sequenceNumber,
    fileModuleId
  }

  const response = await axiosInstance.post('/api/fines/draft/calculateFines', params)

  const { finesAmount, overstayDays, legalExitDate, finesCalculationDate, isCanceledFlag } =
    response

  const compiledObjectResponse = {
    finesAmount,
    overstayDays,
    legalExitDate,
    finesCalculationDate,
    isCanceledFlag
  }

  formStore.form.setValues(compiledObjectResponse)

  Object.assign(formStore.draft.request, compiledObjectResponse)

  const fileTypes = [2, 3, 7]
  const { enableAutoCreateIssueLeavingPermitRequestWhilePayingFines } = client_config
  const { applicationId } = authStore.user
  const { resident, citizen, gcc_citizen, establishment, TypingCenter, guest } =
    client_lookups.application

  const isCancelled = isCanceledFlag === 1
  const isFileType = fileTypes.some((ft) => ft === +serviceCode)
  const isEligibleToAddLeavePermitRelatedDraft = [
    resident,
    citizen,
    gcc_citizen,
    establishment,
    TypingCenter,
    guest
  ].some((app) => app === +applicationId)

  const isNumber = (x) => typeof x === 'number' && !isNaN(x)

  const isFinesAmountValidNumber = isNumber(finesAmount)
  const isOverstayDaysValidNumber = isNumber(overstayDays)

  const showLeavePermitRequestSection =
    enableAutoCreateIssueLeavingPermitRequestWhilePayingFines &&
    isCancelled &&
    isFileType &&
    isEligibleToAddLeavePermitRelatedDraft &&
    isFinesAmountValidNumber &&
    isOverstayDaysValidNumber

  Object.assign(formStore.extraMap, { showLeavePermitRequestSection })
}

async function validateSecurityDepositRequest(params) {
  const formStore = useFormStore()

  const path = '/api/requestmaster/validateSecurityDepositRequest'
  const response = await axiosInstance.get(path, { params })

  const { administrativeRegionId, paymentMethodId } = response

  Object.assign(formStore.extraMap, {
    administrativeRegionId
  })

  const secDepPath = `/api/requestmaster/get/${params.refRequestNumber}`
  const secDepResponse = await axiosInstance.get(secDepPath)

  const { englishApplicantName, arabicApplicantName } = secDepResponse

  formStore.form.setValues({
    englishApplicantNameOriginal: englishApplicantName,
    arabicApplicantNameOriginal: arabicApplicantName,
    paymentMethodId: paymentMethodId
  })
  formStore.draft.request = {
    ...formStore.draft.request,
    englishApplicantNameOriginal: englishApplicantName,
    arabicApplicantNameOriginal: arabicApplicantName,
    paymentMethodId: paymentMethodId
  }
}

const checkMainRequest = async () => {
  const formStore = useFormStore()
  const { referenceRequestNumber = '' } = formStore.form.values || formStore.draft.request
  let res = await apiHelperService.get(
    `/api/requestmaster/validateIfNewBornResiOrLeavePermitRequest/${referenceRequestNumber}`
  )
  if (res.message) {
    notify(
      {
        group: 'error',
        title: i18n.global.t('warningTitle'),
        text: res.message
      },
      6000
    )
    return
  }
  if (res.resultData) {
    const {
      unifiedNumber = '',
      englishFullName = '',
      arabicFullName = '',
      dateOfBirth = '',
      passportNumber = '',
      passportTypeId = '',
      nationalityId = '',
      genderId = '',
      religionId = ''
    } = res.resultData
    formStore.draft.request = {
      ...formStore.draft.request,
      personUnifiedNumber: unifiedNumber,
      englishName: englishFullName,
      arabicName: arabicFullName,
      dateOfBirth,
      passportNumber,
      passportTypeId,
      currentNationalityId: nationalityId,
      genderId,
      religionId
    }
  }
}

const fetchSecondaryActivities = async () => {
  const formStore = useFormStore()
  const authStore = useAuthStore()

  if (!authStore.establishmentInfo) {
    await authStore.fetchEstablishmentInfo()
  }

  const { estabEconomicActivitiesIds } = authStore.establishmentInfo
  // sample data: keep me! const estabEconomicActivitiesIds = '998,997,996'
  if (!estabEconomicActivitiesIds) {
    formStore.form.setFieldValue('secondaryActivitiesList', i18n.global.t('noDataFound'))
    return
  }

  const activityIds = estabEconomicActivitiesIds.split(',')

  const promises = activityIds.map(async (id) => {
    const params = {
      id
    }
    return await axiosInstance.get('/api/lookup/economicActivityAutoComplete', { params })
  })

  const activityResponses = await Promise.all(promises)
  const secondaryActivitiesList = activityResponses.map(([{ localizedName }]) => localizedName)
  formStore.form.setFieldValue('secondaryActivitiesList', secondaryActivitiesList.join(' | '))
}

const checkCancelResidencyWithoutSposnored = async () => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const {
    user: { applicationId }
  } = authStore
  const { referenceRequestNumber } = formStore.form.values
  const { cancelResidencyWithoutSponsored, is445 } = formStore.extraMap
  const {
    transactionReason: { uponSponsorRequest }
  } = client_lookups
  if (referenceRequestNumber) {
    const res = await apiHelperService.get(
      [2, 3].includes(applicationId)
        ? `/api/typingCenter/request/cancelResidencyWithoutSposnored/${referenceRequestNumber}`
        : `/api/individual/request/cancelResidencyWithoutSposnored/${referenceRequestNumber}`
    )
    if (!res) {
      notify(
        {
          group: 'error',
          title: '',
          text: i18n.global.t('humantarianExceptionNotExist')
        },
        6000
      )
      formStore.extraMap.validCancelResidencyWithoutSposnoredNumber = false
      formStore.form.setFieldValue('referenceRequestNumber', undefined)
      return
    }
    formStore.extraMap.validCancelResidencyWithoutSposnoredNumber = true
    const {
      resiDepartmentCode = '',
      resiYear = '',
      resiServiceCode = '',
      resiSequenceNumber = '',
      identityNumber = '',
      englishName = '',
      arabicName = '',
      motherArabicName = '',
      maritalStatusId = '',
      religionId = '',
      faithId = '',
      currentNationalityId = '',
      genderId = '',
      educationLevelId = '',
      countryOfBirthId = '',
      arabicPlaceOfBirth = '',
      dateOfBirth = '',
      passportNumber = '',
      passportIssueDate = '',
      passportExpiryDate = '',
      passportCountryId = '',
      passportArabicIssuePlace = '',
      passportTypeId = '',
      transactionReasonId = '',
      localAddress = '',
      localEmirateId = '',
      localCityId = '',
      buildingName = '',
      localPobox = '',
      localHomePhone = '',
      localWorkPhone = '',
      localMobile = '',
      sponsorDepartmentId = '',
      sponsorEnglishName = '',
      sponsorArabicName = '',
      sponsorNumber = '',
      sponsorRelationshipId = '',
      sponsorTypeId = '',
      sponsorMobile = '',
      sponsorMonthlyIncome = '',
      deathDate = ''
    } = res
    formStore.draft.request = [
      ...formStore.draft.request,
      resiDepartmentCode,
      resiYear,
      resiServiceCode,
      resiSequenceNumber,
      identityNumber,
      englishName,
      arabicName,
      motherArabicName,
      maritalStatusId,
      religionId,
      faithId,
      currentNationalityId,
      genderId,
      educationLevelId,
      countryOfBirthId,
      arabicPlaceOfBirth,
      dateOfBirth,
      passportNumber,
      passportIssueDate,
      passportExpiryDate,
      passportCountryId,
      passportArabicIssuePlace,
      passportTypeId,
      transactionReasonId,
      localAddress,
      localEmirateId,
      localCityId,
      buildingName,
      localPobox,
      localHomePhone,
      localWorkPhone,
      localMobile,
      sponsorDepartmentId,
      sponsorEnglishName,
      sponsorArabicName,
      sponsorNumber,
      sponsorRelationshipId,
      sponsorTypeId,
      sponsorMobile,
      sponsorMonthlyIncome,
      deathDate
    ]
    if (!cancelResidencyWithoutSponsored && !is445) {
      formStore.draft.request.transactionReasonId = uponSponsorRequest
    }
  }
}
async function getRefundRequestNumber() {
  const formStore = useFormStore()
  const { moduleId, departmentCode, serviceYear, typeCode, sequenceNumber } = formStore.form.values

  if ([moduleId, departmentCode, serviceYear, typeCode, sequenceNumber].some((value) => !value)) {
    return
  }

  const params = {
    moduleId,
    departmentCode,
    serviceYear,
    typeCode,
    sequenceNumber
  }
  const response = await axiosInstance.get('/api/refundRequest/fileNumber', { params })

  if (!response) return

  Object.assign(formStore.draft.request, {
    referenceRequestNumber: response.number
  })
  formStore.form.setFieldValue('referenceRequestNumber', response.number)
}
async function checkIfVirtualSponsorByUniNumOrFileNumber() {
  const formStore = useFormStore()
  const {
    personUnifiedNumber = '',
    departmentCode = '',
    serviceYear = '',
    serviceCode = '',
    sequenceNumber = ''
  } = formStore.form.values

  if (!personUnifiedNumber && !departmentCode && !serviceYear && !serviceCode && !sequenceNumber)
    return

  const params = {
    unifiedNumber: personUnifiedNumber,
    moduleId: 2,
    ...(departmentCode && { departmentCode }),
    ...(serviceYear && { resiYear: serviceYear }),
    ...(serviceCode && { resiServiceCode: serviceCode }),
    ...(sequenceNumber && { resiSequenceNumber: sequenceNumber })
  }

  const response = await axiosInstance.get('/api/user/checkIfVirtualSponsorByUniNumOrFileNumber', {
    params
  })
  if (!response) return
  formStore.extraMap.hideSponsorInformation = false
  if (response.isVirtualSponsor) {
    formStore.extraMap.hideSponsorInformation = true
    formStore.draft.request = {
      ...formStore.draft.request,
      sponsorNumber: '',
      sponsorIdentityNumber: '',
      sponsorTypeId: '',
      sponsorDepartmentId: '',
      sponsorEnglishName: '',
      sponsorArabicName: '',
      sponsorIdentityNumber: ''
    }
  }
}

async function getWorkPermit() {
  const formStore = useFormStore()
  const {
    workPermitNumber = '',
    sponsorNumber = '',
    sponsorDepartmentId = ''
  } = formStore.form.values
  if (!workPermitNumber || !sponsorNumber) return
  const res = await axiosInstance.get(`/api/mol/workPermit/${workPermitNumber}`, {
    params: {
      sponsorUnifiedNumber: sponsorNumber,
      estabNumber: sponsorNumber,
      departmentId: sponsorDepartmentId
    }
  })
  if (!res) {
    notify(
      {
        group: 'error',
        title: '',
        text: i18n.global.t('workPermitNumberNotExist')
      },
      6000
    )
    return
  }
  if (res.fileStatusId != 18) {
    notify(
      {
        group: 'error',
        title: '',
        text: i18n.global.t('wrongWorkPermitStatus')
      },
      6000
    )
    return
  }
  formStore.extraMap.validNumber = true
  formStore.extraMap.validVisaStatus = true
  const {
    professionId = '',
    englishName = '',
    arabicName = '',
    currentNationalityId = '',
    previousNationalityId = '',
    genderId = '',
    dateOfBirth = '',
    countryOfBirthId = '',
    englishPlaceOfBirth = '',
    arabicPlaceOfBirth = '',
    passportNumber = '',
    passportTypeId = '',
    passportEnglishIssuePlace = '',
    passportArabicIssuePlace = '',
    passportCountryId = '',
    passportExpiryDate = '',
    passportIssueDate = '',
    religionId = '',
    faithId = '',
    maritalStatusId = '',
    motherArabicName = '',
    motherEnglishName = '',
    localMobile = '',
    abroadPhone = '',
    localHomePhone = '',
    abroadCountryId = '',
    sponsorTypeId = ''
  } = res
  formStore.draft.request = {
    ...formStore.draft.request,
    professionId,
    englishName,
    arabicName,
    currentNationalityId,
    previousNationalityId,
    genderId,
    dateOfBirth,
    countryOfBirthId,
    englishPlaceOfBirth,
    arabicPlaceOfBirth,
    passportNumber,
    passportTypeId,
    passportEnglishIssuePlace,
    passportArabicIssuePlace,
    passportCountryId,
    passportExpiryDate,
    passportIssueDate,
    religionId,
    faithId,
    maritalStatusId,
    motherArabicName,
    motherEnglishName,
    localMobile,
    abroadPhone,
    localHomePhone,
    abroadCountryId,
    sponsorTypeId,
    sponsorNumber: res.sponsorNumber
  }
}
async function getEstablishWorkPermit() {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { workPermitNumber = '' } = formStore.form.values
  const {
    departmentCode = '',
    serviceYear = '',
    serviceCode = '',
    sequenceNumber = ''
  } = formStore.form.values.searchCriteria || {}
  const isFileVisa = !departmentCode || !serviceYear || !serviceCode || !sequenceNumber
  if (!workPermitNumber || (serviceTransactionId == 1011 && isFileVisa)) return
  const res = await axiosInstance.get(`/api/mol/workPermit/${workPermitNumber}`)
  if (!res) {
    notify(
      {
        group: 'info',
        title: '',
        text: i18n.global.t('workPermitNumberNotExist')
      },
      6000
    )
    formStore.extraMap.validNumber = false
    return
  }
  if (res.fileStatusId != 18) {
    notify(
      {
        group: 'info',
        title: '',
        text: i18n.global.t('wrongWorkPermitStatus')
      },
      6000
    )
    formStore.extraMap.validNumber = false

    return
  }

  const {
    visaDepartmentCode = '',
    visaServiceYear = '',
    visaServiceCode = '',
    visaSequenceNumber = ''
  } = res || {}
  if (
    serviceTransactionId == 1011 &&
    (visaDepartmentCode != departmentCode ||
      visaServiceYear != serviceYear ||
      visaServiceCode != serviceCode ||
      visaSequenceNumber != sequenceNumber)
  ) {
    notify(
      {
        group: 'info',
        title: '',
        text: i18n.global.t('visaFileNotValid')
      },
      6000
    )
    formStore.extraMap.validNumber = false
  }
  formStore.extraMap.validNumber = true
  formStore.extraMap.validVisaStatus = true
  const {
    personUnifiedNumber = '',
    passportFile = '',
    professionId = '',
    englishName = '',
    arabicName = '',
    currentNationalityId = '',
    previousNationalityId = '',
    genderId = '',
    dateOfBirth = '',
    countryOfBirthId = '',
    englishPlaceOfBirth = '',
    arabicPlaceOfBirth = '',
    passportNumber = '',
    passportTypeId = '',
    passportEnglishIssuePlace = '',
    passportArabicIssuePlace = '',
    passportCountryId = '',
    passportExpiryDate = '',
    passportIssueDate = '',
    religionId = '',
    faithId = '',
    maritalStatusId = '',
    motherArabicName = '',
    motherEnglishName = '',
    localMobile = '',
    abroadPhone = '',
    localHomePhone = '',
    abroadCountryId = '',
    sponsorTypeId = '',
    sponsorNumber = '',
    sponsorDepartmentId = '',
    arabicProfession = '',
    englishProfession = '',
    sponsoredEntryStatus = ''
  } = res
  formStore.draft.request = {
    ...formStore.draft.request,
    professionId,
    englishName,
    arabicName,
    currentNationalityId,
    previousNationalityId,
    genderId,
    dateOfBirth,
    countryOfBirthId,
    englishPlaceOfBirth,
    arabicPlaceOfBirth,
    passportNumber,
    passportTypeId,
    passportEnglishIssuePlace,
    passportArabicIssuePlace,
    passportCountryId,
    passportExpiryDate,
    passportIssueDate,
    religionId,
    faithId,
    maritalStatusId,
    motherArabicName,
    motherEnglishName,
    localMobile,
    abroadPhone,
    localHomePhone,
    abroadCountryId,
    sponsorTypeId,
    sponsorNumber,
    personUnifiedNumber,
    sponsorDepartmentId,
    arabicProfessionName: arabicProfession,
    englishProfessionName: englishProfession,
    sponsoredEntryStatus,
    ...(serviceTransactionId == 1011 && {
      departmentCode: visaDepartmentCode,
      serviceYear: visaServiceYear,
      serviceCode: visaServiceCode,
      sequenceNumber: visaSequenceNumber
    })
  }
  if (passportFile) {
    formStore.extraMap.molPassport = passportFile
  }
}

function checkOtpShow() {
  const formStore = useFormStore()
  const {
    establishmentSponsorType = '',
    establishmentNumber = '',
    sponsorUnifiedNumber = '',
    currentPassword = ''
  } = formStore.form.values
  formStore.extraMap.showsendOTPForm = false
  if (establishmentSponsorType && establishmentNumber && sponsorUnifiedNumber && currentPassword) {
    formStore.extraMap.showsendOTPForm = true
    getMobileNumbers()
  }
}

async function getMobileNumbers() {
  const formStore = useFormStore()
  const {
    establishmentNumber = '',
    establishmentSponsorType = '',
    sponsorUnifiedNumber = '',
    establishmentLicenceIssueDate = '',
    currentPassword = ''
  } = formStore.form.values
  const {
    establishmentCancellationReasons: { establishmentSubscriptionCancellationId }
  } = lookups
  const res = await axiosInstance.post(`/api/userForCancelSub/CheckOrganizationInfo`, {
    EstabCardNumber: `${establishmentNumber}/${establishmentSponsorType}`,
    Number: establishmentNumber,
    SponsorTypeCode: establishmentSponsorType,
    SponsorUnifiedNumber: sponsorUnifiedNumber,
    LicenceIssueDate: establishmentLicenceIssueDate,
    CurrentPassword: currentPassword,
    TransactionReasonId: establishmentSubscriptionCancellationId
  })
  if (!res || !res.isOtpEnabled) return
  if (res.sponsorMobileNumbers?.length > 0) {
    formStore.extraMap.registeredNumbers = res.sponsorMobileNumbers || []
  } else {
    formStore.extraMap.registeredNumbers = []
    notify(
      {
        group: 'error',
        title: i18n.global.t('NoMobleNumbersExistMsgTitle'),
        text: i18n.global.t('NoMobleNumbersExistMsg')
      },
      6000
    )
  }
}

async function getIdentityNumberOrUnifiedNumberWithoutAutoFill(params) {
  const formStore = useFormStore()
  const res = await axiosInstance.get(
    `/api/typingCenter/citizenServices/draft/usersInfoByIdentityNumberOrUnifiedNumberWithoutAutoFill`,
    {
      params
    }
  )
  if (!res) return
  const { identityCardNumber = '', unifiedNumber = '' } = res
  formStore.draft.request = {
    ...formStore.draft.request,
    personUnifiedNumber: unifiedNumber || params.identityNumberOrUnifiedNumber,
    identityNumber: identityCardNumber || params.identityNumberOrUnifiedNumber
  }
}

async function getPersonInfoFromEdia(params) {
  const {
    ServiceTransactions: {
      residenceForResidentFamilyWorkingInPublicSector,
      ResidenceForResidentFamilyWorkingInPrivertSectorOrFreezone,
      visaForResidentWorkingForUaeCitizenOrGccCitizenSponsores
    }
  } = client_lookups

  const formStore = useFormStore()
  const response = await axiosInstance.get('/api/user/getPersonInfoFromEdia', { params })

  formStore.draft.request.isUsingSponsorIdentityCard = false

  if (Object.keys(response || {}).length === 0) {
    notify(
      {
        group: 'warning',
        title: i18n.global.t('warningMessageNoSponsorinfo'),
        text: i18n.global.t('warningTitle')
      },
      6000
    )
  }

  // setSponsorType
  const { serviceId } = router.currentRoute.value.params

  const isIncludedService = [
    residenceForResidentFamilyWorkingInPublicSector,
    ResidenceForResidentFamilyWorkingInPrivertSectorOrFreezone,
    visaForResidentWorkingForUaeCitizenOrGccCitizenSponsores
  ].includes(serviceId)

  Object.assign(formStore.extraMap, {
    isResidentFamilyWorkingInPublicSector: isIncludedService
  })

  formStore.draft.request = {
    ...formStore.draft.request,
    ...response,
    isUsingSponsorIdentityCard: true,
    sponsorTypeId: 4,
    sponsorTypeCode: 3
  }

  formStore.form.setValues({
    sponsorNumber: response.personUnifiedNumber,
    sponsorGenderId: response.gender,
    sponsorNationalityId: response.nationalityId,
    sponsorTypeId: 4
  })
}

async function getPersonInfo() {
  const formStore = useFormStore()
  const {
    resiDepartmentCode = '',
    resiYear = '',
    resiServiceCode = '',
    resiSequenceNumber = '',
    sponsorNumber = '',
    sponsorDepartmentId = ''
  } = formStore.form.values
  const fileNumber = `${resiDepartmentCode}${resiYear}"0"${resiServiceCode.slice(-2)}000000${resiSequenceNumber.slice(-7)}`
  if (
    !resiDepartmentCode ||
    !resiYear ||
    !resiServiceCode ||
    !resiSequenceNumber ||
    !sponsorNumber ||
    !fileNumber
  )
    return
  try {
    let result = await axiosInstance.get(`/api/establishment/residency/checkSponsorEmployees`, {
      params: {
        fileNumber,
        establishmentNumber: sponsorNumber,
        sponsorDepartmentId
      }
    })
    if (!result) {
      notify(
        {
          group: 'error',
          title: i18n.global.t('Errors'),
          text: i18n.global.t('personInfoErrorMessage')
        },
        6000
      )
      clearDraftObject()
      return
    }
    const {
      englishName = '',
      arabicName = '',
      currentNationalityId = '',
      previousNationalityId = '',
      dateOfBirth = '',
      countryOfBirthId = '',
      genderId = '',
      religionId = '',
      faithId = '',
      educationLevelId = '',
      motherArabicName = '',
      motherEnglishName = '',
      arabicPlaceOfBirth = '',
      englishPlaceOfBirth = '',
      maritalStatusId = '',
      professionId = '',
      passportNumber = '',
      passportTypeId = '',
      passportCountryId = '',
      passportArabicIssuePlace = '',
      passportIssueDate = '',
      passportExpiryDate = ''
    } = result
    formStore.draft.request = {
      ...formStore.draft.request,
      fileNumber,
      englishName,
      arabicName,
      currentNationalityId,
      previousNationalityId,
      dateOfBirth,
      countryOfBirthId,
      genderId,
      religionId,
      faithId,
      educationLevelId,
      maritalStatusId,
      motherArabicName: motherArabicName ? motherArabicName : motherEnglishName,
      ...(arabicPlaceOfBirth && { arabicPlaceOfBirth }),
      ...(arabicPlaceOfBirth && { englishPlaceOfBirth }),
      professionId,
      passportNumber,
      passportTypeId,
      passportCountryId,
      passportArabicIssuePlace,
      passportIssueDate,
      passportExpiryDate
    }
    formStore.extraMap = {
      ...formStore.extraMap,
      hideFreeDepositeTitle: false,
      hidePassportInformation: false,
      hidePersonalInformation: false,
      hideAccompanies: false
    }
  } catch (error) {
    console.error('checkSponsorEmployees', error)
    if (error.indexOf('ORA-01403') != -1) {
      notify(
        {
          group: 'error',
          title: i18n.global.t('Errors'),
          text: i18n.global.t('personInfoNotFound')
        },
        6000
      )
      clearDraftObject()
    }
  }
}

function clearDraftObject() {
  const formStore = useFormStore()
  formStore.draft.request = {
    ...formStore.draft.request,
    resiDepartmentCode: '',
    resiYear: '',
    resiServiceCode: '',
    resiSequenceNumber: '',
    fileNumber: '',
    englishName: '',
    arabicName: '',
    currentNationalityId: '',
    previousNationalityId: '',
    dateOfBirth: '',
    countryOfBirthId: '',
    genderId: '',
    religionId: '',
    faithId: '',
    educationLevelId: '',
    maritalStatusId: '',
    motherArabicName: '',
    motherArabicName: '',
    arabicPlaceOfBirth: '',
    englishPlaceOfBirth: '',
    professionId: '',
    passportNumber: '',
    passportTypeId: '',
    passportCountryId: '',
    passportArabicIssuePlace: '',
    passportIssueDate: '',
    passportExpiryDate: ''
  }
}

function validateGpa() {
  const formStore = useFormStore()

  const { gpa } = formStore.form.values

  if (isGpaDecimalValid(gpa)) return

  formStore.form.resetField('gpa')
  formStore.form.setTouched('gpa')
  formStore.form.validateField('gpa')

  notify(
    {
      group: 'error',
      title: i18n.global.t('gpaMustBeOutOf35')
    },
    6000
  )
}

async function checkPersonalInfoByIdentity(param) {
  const formStore = useFormStore()
  const authStore = useAuthStore()

  const { personUnifiedNumber, identityNumber } = formStore.form.values

  const tokens = {}

  if (Object.keys(authStore?.user || {}).length > 0) {
    const { userToken, refreshToken } = authStore.user
    Object.assign(tokens, {
      userToken,
      refreshToken
    })
  }

  try {
    const response = await axiosNoResponseInterceptor.get(
      '/api/NominationGoldenVisa/draft/getPersonalDetails',
      {
        params: {
          unifiedNumber: personUnifiedNumber,
          identityNumber
        }
      }
    )

    if (!response) throw new Error()

    /**
     * TODO: show confirmation and then on false
     * formStore.form.resetField('personUnifiedNumber')
     * formStore.form.resetField('identityNumber')
     *
     * loc: $scope.checkPersonalInfoByIdentity on
     * shared/pages/goldenVisaNomination/request/step1/goldenVisaNominationRequest.step1Ctrl.js
     *
     * for establishment users
     */
  } catch (error) {
    formStore.form.resetField('personUnifiedNumber')
    formStore.form.resetField('identityNumber')

    notify(
      {
        group: 'error',
        title: i18n.global.t('error'),
        text: i18n.global.t('personNumberIsWrongOrNotRelated')
      },
      6000
    )
  }
}

/**
 * combination of
 * checkConductIdentificationCodeCertificate (onChange)
 * and checkSponsorRule (blur)
 */
async function handleUnifiedNumberBlur(params) {
  const servicesThatUseThis = [47, 48]
  const { serviceId } = router.currentRoute.value.params

  // early return for service forms that don't have to use this
  if (servicesThatUseThis.includes(+serviceId) === false) return

  const isViolatedFilesRoute = [47, 48]
  if (isViolatedFilesRoute.includes(+serviceId)) {
    const { source = null } = params
    return await checkForViolatedFiles(source)
  }

  await checkConductIdentificationCodeCertificate()
}

async function checkConductIdentificationCodeCertificate() {
  const globalStore = useGlobalStore()
  const formStore = useFormStore()

  const { showConductIdentificationCodeCertificate } = globalStore.startedService

  const { personUnifiedNumber, dateOfBirth, currentNationalityId, passportNumber, passportTypeId } =
    formStore.form.values || formStore.draft.request

  const hasNationality = !!currentNationalityId
  const hasPassportInfo = [passportNumber, passportTypeId].some((x) => !!x)
  const hasUnifiedNumber = !!personUnifiedNumber

  if (
    !showConductIdentificationCodeCertificate ||
    !dateOfBirth ||
    (!(hasNationality && hasPassportInfo) && !hasUnifiedNumber)
  ) {
    formStore.form.setValues({
      conductIdentificationCodeCertificate: null
    })

    Object.assign(formStore.extraMap, {
      showConductIdentificationCodeCertificate: false
    })
    return
  }

  const payload = {
    unifiedNumber: personUnifiedNumber,
    passportNumber,
    passportTypeId,
    currentNationalityId,
    dateOfBirth
  }
  const response = await axiosInstance.post(
    '/api/requestmaster/showConductIdentificationCodeCertificate',
    payload
  )

  if (response) {
    formStore.form.setValues({
      conductIdentificationCodeCertificate: null
    })

    Object.assign(formStore.extraMap, {
      showConductIdentificationCodeCertificate: response
    })
  }
}

export default function () {
  return {
    checkIfPersonHasGoldenVisa,
    checkPersonUnifiedNumberChange: use922Actions().checkPersonUnifiedNumberChange,
    getPersonInfoAndPrepareForm: use920Actions().getPersonInfoAndPrepareForm,
    checkSponsorRule: use919Actions().checkSponsorRule,
    checkUnifiedNumber: use573Actions().checkUnifiedNumber,
    getPersonInfoByFileNumber,
    checkPersonInfo: use446Actions().checkPersonInfo,
    getWifeInfoByIdntityNumberAndUnifiedNumber,
    checkIbanIfMatchingRefundBanks: (params) =>
      use663Actions('checkIbanIfMatchingRefundBanks', params),
    checkValidEidaRequest: (params) => use663Actions('checkValidEidaRequest', params),
    checkForViolatedFiles,
    getIndivInfoByIdnNumOrUnNumFamilyMem: (params) =>
      use719Actions('getIndivInfoByIdnNumOrUnNumFamilyMem', params),
    getIndivInfoByIdnNumOrUnNumForChildsFamily: (params) =>
      use719Actions('getIndivInfoByIdnNumOrUnNumForChildsFamily', params),
    loadDraftAfterCloning,
    cloneRequestDraft,
    checkEligibility,
    usersInfoByIdnOrUnifiedNumberOnly: (params) =>
      use713Actions('usersInfoByIdnOrUnifiedNumberOnly', params),
    checkInistialApprovalRequest: (params) => use140Actions('checkInistialApprovalRequest', params),
    searchRefundWhiteList: (params) => use375Actions('searchRefundWhiteList', params),
    getRequestNumber: (params) => use376Actions('getRequestNumber', params),
    checkFatherIdentityInfo: (params) => use838Actions('checkFatherIdentityInfo', params),
    checkChildIdentityInfo: (params) => use838Actions('checkChildIdentityInfo', params),
    checkInitialApprovalRequest,
    fetchFines,
    validateSecurityDepositRequest,
    checkPersonEligibleity: (params) => use761Actions('checkPersonEligibleity', params),
    checkMainRequest,
    fetchSecondaryActivities,
    checkCancelResidencyWithoutSposnored,
    getRefundRequestNumber,
    checkViolatedFiles: (params) => use445Actions('checkViolatedFiles', params),
    ...use24Actions(),
    getIdentityNumberOrUnifiedNumber,
    establishmentDepartmentChange: () => use162Actions('establishmentDepartmentChange'),
    ...use57Actions(),
    checkIfVirtualSponsorByUniNumOrFileNumber,
    checkBeneficiary,
    getWorkPermit,
    getEstabFines: () => use440Actions('getEstabFines'),
    checkIfSponsoredByEstablishment: use446Actions().checkIfSponsoredByEstablishment,
    checkOtpShow,
    checkPersonIdentityNumber: (params) => use495Actions().checkPersonIdentityNumber(params),
    checkPersonUnifiedNumber: (params) => use495Actions().checkPersonUnifiedNumber(params),
    checkLeavePermitNumber: use495Actions().checkLeavePermitNumber,
    checkInvestigationCancelFines: use495Actions().checkInvestigationCancelFines,
    getIdentityNumberOrUnifiedNumberWithoutAutoFill,
    checkIsSameEmail: () => use714Actions('checkIsSameEmail'),
    getPersonInfoFromEdia,
    getPersonInfo,
    getEstablishWorkPermit,
    validateGpa,
    checkPersonalInfoByIdentity,
    handleUnifiedNumberBlur
  }
}
